import { render, staticRenderFns } from "./BZLtable.vue?vue&type=template&id=1d376484&scoped=true"
import script from "./BZLtable.vue?vue&type=script&lang=js"
export * from "./BZLtable.vue?vue&type=script&lang=js"
import style0 from "./BZLtable.vue?vue&type=style&index=0&id=1d376484&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d376484",
  null
  
)

export default component.exports